'use strict';

/* CQ Article Service */

import scriptLoader from "../../fsUtils/ScriptLoader";

angular.module('storyApp').factory('cqArticleService', ['$http', '$q', function($http, $q) {

    var service = {
        
        articles: [],
        urls: [],
        onRenderArticle: null,
        
        addArticle: function(url, articleUrl){
            
            var that = this;
            
            that.articles.push({
                'url': url,
                'articleUrl': articleUrl,
                'isFetched' : false,
                'isFetching' : false,
                'isRendered' : false,
                'content' : null,
                'metadata' : null,
                'httpPromise' : null
            });
            
            return that;
        },
        addArticleContent: function(relatedIndex, content){
            
            var that = this;
            
            that.articles[relatedIndex].content = content;
            
            return that;
            
        },
        getUrl: function(relatedIndex){
            var that = this;
            
            return that.articles[relatedIndex].url;
        },
        
        getArticleUrl: function(relatedIndex){
            var that = this;
            
            return that.articles[relatedIndex].articleUrl;
        },
        
        fetchArticle: function(relatedIndex) {
            
            var deferred = $q.defer(),
                that = this,
                url = that.getArticleUrl(relatedIndex);
                
            //check first if article have been fetched    
            if(!that.articles[relatedIndex].isFetched){
                
                 /** 
                 ** need to watch the following logic
                 **/
                
                //mark fetch and returm promise of current ajax call
                if(that.articles[relatedIndex].isFetching){
                    
                    //console.log("being fetch for related, promise returned ", relatedIndex);
                    
                    return that.articles[relatedIndex].httpPromise;
                    
                }else{
                    
                    that.articles[relatedIndex].isFetching = true;
                    
                    //console.log("starting fetch for related ", relatedIndex);
                    
                    that.articles[relatedIndex].httpPromise = deferred.promise;
                    
                    $http({
                        method: 'GET',
                        url: url
                    }).success(function(data) {
            
                        //data = that.getMetadata(data);
                        that.addArticleContent(relatedIndex,data);
                        that.articles[relatedIndex].isFetched = true;
                        that.articles[relatedIndex].isFetching = false;
                        that.articles[relatedIndex].metadata = that.setMetadata(data);
                        
                        deferred.resolve(data);
            
                    }).error(function() {
                        deferred.reject("There was an error getting story");
                        //fallback implementation here if it is needed
                    })
            
                    return deferred.promise;
                    
                }
                
            }else{
                
                //console.log("related article is already fetched for ", relatedIndex);
                
                return that.articles[relatedIndex].httpPromise;
                
            }
            
            
        },

        /**
         * @desc inject video and gallery css to the head based on the first story onLoad
         * @param metadata Meta object from the next rendering story
         */
        loadVideoGalleryAssets: function( metadata ) {

            if ( metadata !== undefined ) {


                var mainArticlePageType = mainArticlePageType || this.getMainArticlePageType();

                var nextRenderedArticleType = metadata.analytics.page_type;

                //check if the main story (first) is story
                if ('story' === mainArticlePageType) {
                    //check if the next rendered article is video, if it is yes, load video css
                    if ('video' === nextRenderedArticleType) {
                        scriptLoader.getStyles(metadata.meta.videocss);
                        //otherwise, check if the next rendered article is gallery, if it is yes, load gallery css
                    } else if ('gallery' === nextRenderedArticleType) {
                        scriptLoader.getStyles(metadata.meta.gallerycss);
                    }
                    //check if the main story (first) is video
                } else if ('video' === mainArticlePageType) {
                    //check if the next rendered article is gallery, if it is yes, load gallery css
                    if ('gallery' === nextRenderedArticleType) {
                        scriptLoader.getStyles(metadata.meta.gallerycss);
                    }
                    //check if the main story (first) is gallery
                } else if ('gallery' === mainArticlePageType) {
                    //check if the next rendered article is video, if it is yes, load video css
                    if ('video' === nextRenderedArticleType) {
                        scriptLoader.getStyles(metadata.meta.videocss);
                    }
                }
            }
        },

        getMainArticlePageType: function() {
            return document.querySelector('[fs-prop="analytics"]').getAttribute('page-type');
        },
        
        getMetadata: function(relatedIndex){

            var that = this;

            return that.articles[relatedIndex].metadata;

        },
        setMetadata: function(content){

            //parse meta data from article API response and return an object that holds the article content and meta data
            var metadata = content.split('<script id="page-information" type="text/fs-metadata">')[1];

            if (typeof metadata !== 'undefined' && metadata !== null) {

                metadata = metadata.split('</script>')[0];

                return JSON.parse(metadata);
            }

        },
 
        renderArticle: function(relatedIndex, callback){

            var that = this;
            
            //check if already rendered
            if(that.articles[relatedIndex].isRendered == false && that.articles[relatedIndex].content !== null){
                
                if (that.onRenderArticle !== null && typeof that.onRenderArticle === 'function') {

                    this.loadVideoGalleryAssets(that.articles[relatedIndex].metadata);

                    //set callback for rendering
                    that.onRenderArticle(relatedIndex,that.articles[relatedIndex].content);

                    that.loadScriptsAfterRender(that.articles[relatedIndex].content);
                    
                    that.articles[relatedIndex].isRendered = true;

                }
                
                return true;
                
            }else{
                
                return false;
                
            }
            
            
        },

        loadScriptsAfterRender: function(htmlString){

            //console.log("3things - after render" , htmlString);

            var fragment = document.createDocumentFragment();
            var rootEl = document.createElement('div'); 

            rootEl.innerHTML = htmlString;
            fragment.appendChild(rootEl);

            var allScripts = [].slice.call(fragment.querySelectorAll('script:not([type*=template]):not(#page-information)'));

            allScripts.map((scriptEl) => {

                if (scriptEl.src) {
                    scriptLoader.getScript(scriptEl.src, null , false);
                } else {
                    var evalScript = window.setTimeout(function(){
                        eval(scriptEl.innerText);
                        window.clearTimeout(evalScript);
                    },0);
                }
            });
            


        }
    };

    window.cqArticleService = service;


    return service;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/cqArticleService.js